var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[(_vm.theme)?_c('sub-header'):_vm._e(),_vm._v(" "),(_vm.pageTemplate && _vm.$isNotNullOrUndefined(_vm.content))?_c(_vm.pageTemplate,{tag:"component",attrs:{"content":_vm.content}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }